module.exports = __webpack_public_path__ + "static/media/bostech.af042dd9.webp";